(function () {
  'use strict';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  var focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  var AgeGateOverlay = /** @class */ (function () {
    function AgeGateOverlay(el) {
      this.el = el;
      this.cookieName = el.dataset.cookieName;
      this.cookieDays = parseInt(el.dataset.cookieDays, 10) || 30;
      this.noAction = el.dataset.noAction;
      this.redirectUrl = el.dataset.redirectUrl;
      this.designMode = !!(window.Shopify && window.Shopify.designMode);

      this.question = el.querySelectorAll('[data-age-gate-question]');
      this.rejection = el.querySelector('[data-age-gate-rejection]');
      this.yesBtn = el.querySelector('[data-age-gate-yes]');
      this.noBtn = el.querySelector('[data-age-gate-no]');

      if (!this.designMode && getCookie(this.cookieName) === 'true') {
        el.remove();
        return;
      }

      this.lock();
      this.bindEvents();
      this.focusFirst();
    }

    AgeGateOverlay.prototype.lock = function () {
      document.documentElement.classList.add('age-gate-active');
    };

    AgeGateOverlay.prototype.unlock = function () {
      document.documentElement.classList.remove('age-gate-active');
    };

    AgeGateOverlay.prototype.bindEvents = function () {
      var self = this;

      if (this.yesBtn) {
        this.yesBtn.addEventListener('click', function () {
          self.accept();
        });
      }

      if (this.noBtn) {
        this.noBtn.addEventListener('click', function () {
          self.decline();
        });
      }

      this.el.addEventListener('keydown', function (event) {
        if (event.key === 'Tab') self.maintainFocus(event);
      });
    };

    AgeGateOverlay.prototype.accept = function () {
      setCookie(this.cookieName, 'true', this.cookieDays);
      this.unlock();
      this.el.remove();
    };

    AgeGateOverlay.prototype.decline = function () {
      if (this.noAction === 'redirect' && this.redirectUrl && !this.designMode) {
        window.location.href = this.redirectUrl;
        return;
      }

      this.question.forEach(function (el) {
        el.setAttribute('hidden', '');
      });

      if (this.rejection) {
        this.rejection.removeAttribute('hidden');
        this.rejection.setAttribute('tabindex', '-1');
        this.rejection.focus();
      }
    };

    AgeGateOverlay.prototype.focusFirst = function () {
      var focusable = this.el.querySelectorAll(focusableSelector);
      if (focusable.length) focusable[0].focus();
    };

    AgeGateOverlay.prototype.maintainFocus = function (event) {
      var focusable = this.el.querySelectorAll(focusableSelector);
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    return AgeGateOverlay;
  })();

  document.querySelectorAll('[data-age-gate]').forEach(function (el) {
    new AgeGateOverlay(el);
  });
})();
